import type { SpaceId } from '../spaces';

export interface Artwork {
  viewBox: string;
  svg: string;
}

/**
 * The two artworks are ~700KB of generated isometric paths. They are loaded on
 * demand so a page only pays for the floor it is actually showing, and neither
 * lands in the app's main bundle.
 */
const loaders: Record<SpaceId, () => Promise<Artwork>> = {
  ground: () =>
    import('./ground').then((m) => ({ viewBox: m.SEAT_MAP_VIEWBOX, svg: m.SEAT_MAP_SVG })),
  upper: () =>
    import('./upper').then((m) => ({ viewBox: m.SEAT_MAP_VIEWBOX, svg: m.SEAT_MAP_SVG })),
};

export const loadArtwork = (space: SpaceId): Promise<Artwork> => loaders[space]();
